import { FILTER_CONTEXT_LABELS, FILTER_CONTEXTS } from "@search/api/constants";
import type { DropdownItem, GroupSizeCount, PillItem } from "@search/api/types";
import NumberFilter from "@search/store/filters/primitive/NumberFilter";

const DEFAULT_GROUP_SIZE = 2;

const defaultOption: DropdownItem = Object.freeze({
  value: -999,
  label: "Any group size",
});

function optionLabel(groupSize: number, count: number) {
  if (groupSize === DEFAULT_GROUP_SIZE) {
    return `Standard (${count})`;
  }

  return `${groupSize} (${count})`;
}

class GroupSizeFilter extends NumberFilter {
  constructor(value: number) {
    super({
      defaultValue: defaultOption.value,
      label: FILTER_CONTEXT_LABELS[FILTER_CONTEXTS.group_size],
      name: "groupSize",
      value,
    });
  }

  options(groupSizes: Array<GroupSizeCount> = []) {
    const list = groupSizes.map((item) => {
      const { groupSize, count } = item;

      return {
        label: optionLabel(groupSize, count),
        value: groupSize,
      } as DropdownItem;
    });

    if (list.length > 0) {
      list.unshift(defaultOption);
    }

    return list;
  }

  toPills(): Array<PillItem> {
    if (!this.isSet()) {
      return [];
    }

    const key =
      this.value === DEFAULT_GROUP_SIZE
        ? "Standard Groups"
        : `Groups of ${this.value}`;

    return [{ key, name: this.name }];
  }
}

export default GroupSizeFilter;
export { GroupSizeFilter };
